export const DEFAULT_STOREFRONT_CODE = 'us';
export const DEFAULT_LANGUAGE_BCP47 = 'en-US';
export const NON_SOW_COUNTRIES = ['cn', 'kr'];
